import { render, staticRenderFns } from "./ReservationItem.vue?vue&type=template&id=327c9f48&"
import script from "./ReservationItem.vue?vue&type=script&lang=ts&"
export * from "./ReservationItem.vue?vue&type=script&lang=ts&"
import style0 from "./ReservationItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports